"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("@apollo/client");
const react_suspender_1 = __importDefault(require("react-suspender"));
const MapmakerApi_1 = require("../../client/MapmakerApi");
const MessagePage_1 = __importDefault(require("../shared/MessagePage"));
const BlogPostCardList_1 = __importDefault(require("./BlogPostCardList"));
(0, client_1.gql) `
  query allPosts {
    allPost(sort: [{ publishedAt: DESC }]) {
      ...BlogPostCard
    }
  }
`;
function MapmakerBlogPosts() {
    const { loading, error, data } = (0, MapmakerApi_1.useAllPostsQuery)({
        variables: {},
    });
    if (loading) {
        return (0, jsx_runtime_1.jsx)(react_suspender_1.default, {});
    }
    else if (!data || error) {
        return ((0, jsx_runtime_1.jsx)(MessagePage_1.default, Object.assign({ icon: "warning circle" }, { children: "An unexpected error occurred. Please try again." })));
    }
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ id: "mapmaker-blog-posts" }, { children: (0, jsx_runtime_1.jsx)(BlogPostCardList_1.default, { posts: data.allPost }) })));
}
exports.default = MapmakerBlogPosts;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwbWFrZXJCbG9nUG9zdHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9ibG9nL01hcG1ha2VyQmxvZ1Bvc3RzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSwyQ0FBcUM7QUFDckMsc0VBQXdDO0FBQ3hDLDBEQUE0RDtBQUM1RCx3RUFBZ0Q7QUFDaEQsMEVBQWtEO0FBRWxELElBQUEsWUFBRyxFQUFBOzs7Ozs7Q0FNRixDQUFDO0FBRUYsU0FBd0IsaUJBQWlCO0lBQ3ZDLE1BQU0sRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLElBQUksRUFBRSxHQUFHLElBQUEsOEJBQWdCLEVBQUM7UUFDaEQsU0FBUyxFQUFFLEVBQUU7S0FDZCxDQUFDLENBQUM7SUFFSCxJQUFJLE9BQU8sRUFBRTtRQUNYLE9BQU8sdUJBQUMseUJBQVMsS0FBRyxDQUFDO0tBQ3RCO1NBQU0sSUFBSSxDQUFDLElBQUksSUFBSSxLQUFLLEVBQUU7UUFDekIsT0FBTyxDQUNMLHVCQUFDLHFCQUFXLGtCQUFDLElBQUksRUFBQyxnQkFBZ0IscUVBRXBCLENBQ2YsQ0FBQztLQUNIO0lBRUQsT0FBTyxDQUNMLDhDQUFLLEVBQUUsRUFBQyxxQkFBcUIsZ0JBQzNCLHVCQUFDLDBCQUFnQixJQUFDLEtBQUssRUFBRSxJQUFJLENBQUMsT0FBTyxHQUFJLElBQ3JDLENBQ1AsQ0FBQztBQUNKLENBQUM7QUFwQkQsb0NBb0JDIn0=